export default __webpack_public_path__ + "static/media/logo_dof.feb47f01.png";